import * as icons from '@mui/icons-material';

import type { IconNames } from '@/types/common/icon';

/**
 * プロパティ
 */
export interface IGenericIconProps {
  /** アイコン名 */
  iconName: IconNames;
}

/**
 * アイコン
 * @param param0 パラメタ
 * @returns コンポーネント
 */
export const GenericIcon = ({ iconName }: IGenericIconProps): JSX.Element => {
  const Icon = icons[iconName];
  return <Icon />;
};
